module.exports = __webpack_public_path__ + "img/get-prize.15810bbb.png";